import React from "react";

import StandardModal from "./shared/StandardModal";
import { MoveFocusInside } from "react-focus-lock";
import iconHelpBlue from "assets/IconHelpBlue.svg?url";
import Tooltip from "rc-tooltip";
import { Textarea } from "@chakra-ui/react";
import "rc-tooltip/assets/bootstrap.css";
import { PrimaryButton } from "./shared/button/PrimaryButton";
import { sendAnnouncement } from "js/api/eventApi";
import { useSelectedClassroomStore } from "stores/v2/selectedClassroomStore";

export default class SendMessageModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			currentMessage: "",
			sending: false,
			error: false,
		};
	}

	async sendMessage() {
		if (this.state.currentMessage.length === 0) {
			this.setState({ error: "Please enter a message" });
			return;
		}

		this.setState({ sending: true, error: false });

		const payload = {
			classroom_source_id: this.props.classroomSourceId,
			event_object: {
				event: "MESSAGE",
				value: this.state.currentMessage,
			},
		};
		if (this.props.users) {
			payload.recipients = this.props.users.map((user) => user.username);
		}

		sendAnnouncement(
			this.props.classroomSourceId,
			useSelectedClassroomStore.getState().id,
			this.state.currentMessage,
			this.props.users?.map((user) => user.username)
		)
			.then(() => {
				this.close();
				this.clear();
			})
			.catch(() =>
				this.setState({
					sending: false,
					error: "There was an error sending the message",
				})
			);
	}

	renderButtons = () => {
		let sendButton = <PrimaryButton className="mui-flat-button" label="Send" onClick={this.sendMessage.bind(this)} />;
		if (this.state.sending) {
			sendButton = <PrimaryButton className="mui-flat-button" label={<i className="fa fa-refresh fa-spin fa-fw" />} />;
		}
		return <React.Fragment>{sendButton}</React.Fragment>;
	};

	clear = () => {
		this.setState({ currentMessage: "" });
	};

	close = () => {
		this.setState({ sending: false });
		this.props.onClose();
	};

	handleChange(event) {
		let errorMessage = false;
		if (event.target.value.length >= this.props.maxMessageLength) {
			errorMessage = "".concat("Maximum ", this.props.maxMessageLength, " characters reached");
		} else if (event.target.value.length >= this.props.maxMessageLength - 20) {
			errorMessage = "".concat(event.target.value.length, " of ", this.props.maxMessageLength, " characters");
		}
		this.setState({ currentMessage: event.target.value, error: errorMessage });
	}

	keypressValidation = (event) => {
		if (this.state.currentMessage.length >= this.props.maxMessageLength) {
			event.preventDefault();
		}
	};

	render() {
		return (
			<StandardModal
				size="medium"
				open={this.props.open}
				close={this.close}
				actions={this.renderButtons()}
				header={
					<div className="SendMessageModal_header">
						<h2 className="SendMessageModal_headerText" title="Send a class announcement">
							{this.props.title}
						</h2>
						&nbsp;
						<Tooltip
							placement="bottom"
							trigger={["hover"]}
							destroyTooltipOnHide={true}
							overlayClassName="Tooltip"
							overlay={<span>Learn more</span>}
						>
							<a href="https://docs.classwize.net/help/intro-classtools#announcement" target="_blank" rel="noopener noreferrer">
								<img className="SendMessageModal_helpIcon" src={iconHelpBlue} alt="" />
							</a>
						</Tooltip>
					</div>
				}
			>
				<div>{this.props.subtitle}</div>
				&nbsp;
				<form onSubmit={(ev) => ev.preventDefault()}>
					<MoveFocusInside>
						<Textarea
							className="SendMessageModal_textarea"
							name="messageBody"
							placeholder="Enter your message"
							onChange={this.handleChange.bind(this)}
							value={this.state.currentMessage}
							onKeyPress={this.keypressValidation}
							sx={{ height: "21vh", mh: "290px" }}
						/>
					</MoveFocusInside>
					{this.state.error && <div className={"error"}>{this.state.error}</div>}
				</form>
			</StandardModal>
		);
	}
}
